import React, { useState } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../../middleware/firebase';

type Option = {
  id: string;
  label: string;
};

const OPTIONS: Option[] = [
  { id: 'just_browsing', label: 'Solo estoy cotizando' },
  { id: 'price_issue', label: 'El precio no me convenció' },
  { id: 'prefer_store', label: 'Prefiero comprar en la sucursal' },
  { id: 'product_not_found', label: 'No encontré el producto que buscaba' },
  {
    id: 'checkout_confusing',
    label: 'No entendí / no me pareció seguro el proceso de compra',
  },
  { id: 'other', label: 'Otro' },
];

const QUESTION: string = '¿Tuviste algún inconveniente al finalizar tu pedido?';

const LABEL: string = 'buyingProcess';

const Survey = () => {
  const [selected, setSelected] = useState<string | null>(null);
  const [otherText, setOtherText] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!selected) return;

    try {
      setLoading(true);

      const user = JSON.parse(localStorage.getItem('user') || '{}');

      await addDoc(collection(db, 'surveys'), {
        survey: LABEL,
        answer: selected,
        otherText: selected === 'other' ? otherText.trim() || null : null,
        createdAt: serverTimestamp(),
        user_email: user.email || 'usuario anonimo',
      });

      setSubmitted(true);
    } catch (error) {
      console.error('Error saving survey:', error);
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="related-products-section">
        <p>Gracias por tu respuesta.</p>
      </div>
    );
  }

  return (
    <div className="related-products-section">
      <div className="related-products-header">
        <h3>
          Nos gustaría conocer tu experiencia durante el proceso de compra
        </h3>
        <p className="related-products-subtitle">{QUESTION}</p>
      </div>

      <div className="related-products-grid">
        {OPTIONS.map((option) => (
          <label
            key={option.id}
            style={{ display: 'block', marginBottom: '8px' }}
          >
            <input
              type="radio"
              name="survey"
              value={option.id}
              checked={selected === option.id}
              onChange={() => setSelected(option.id)}
            />{' '}
            {option.label}
          </label>
        ))}
      </div>
      {selected === 'other' && (
        <input
          type="text"
          placeholder="Comentario..."
          value={otherText}
          onChange={(e) => setOtherText(e.target.value)}
          style={{ display: 'block', marginTop: '6px', width: '100%' }}
        />
      )}

      <button
        className="btn btn-cart d-flex mx-auto"
        onClick={handleSubmit}
        disabled={
          !selected || loading || (selected === 'other' && otherText == '')
        }
        style={{ marginTop: '12px' }}
      >
        {loading ? 'Enviando...' : 'Enviar'}
      </button>
    </div>
  );
};

export default Survey;
